import type { OpsMateCustomer } from "../types";
import { OPSMATE_PROFILE_BASE } from "../services/api";
import { Button } from "./Button";

interface CustomerCardProps {
  customer: OpsMateCustomer;
}

export function CustomerCard({ customer }: CustomerCardProps) {
  const firstName = customer.user?.first_name ?? "";
  const lastName = customer.user?.last_name ?? "";
  const fullName = `${firstName} ${lastName}`.trim() || "Unknown";
  const email = customer.user?.email ?? customer.authUser?.email ?? "";
  const isVerified =
    customer.emailVerified ||
    customer.settings?.verification_status === "emailVerified";
  const uid = customer.authUser?.uid;
  const hasIndividualPremium =
    customer.settings?.current_entitlement === "user_level_1";

  function handleOpenProfile() {
    if (uid && typeof Missive !== "undefined") {
      Missive.openURL(`${OPSMATE_PROFILE_BASE}/users/${uid}`);
    }
  }

  return (
    <div className="rounded-lg border border-(--border-color,#e5e7eb) bg-(--card-background,#f9fafb) p-4">
      <div className="mb-2 flex items-center justify-between gap-3">
        <h3 className="text-base font-semibold">{fullName}</h3>
        <span
          className={`rounded-full px-2 py-0.5 text-xs font-medium capitalize ${
            isVerified
              ? "bg-emerald-100 text-emerald-800"
              : "bg-amber-100 text-amber-800"
          }`}
        >
          {isVerified ? "Verified" : "Unverified"}
        </span>
      </div>
      <p className="mb-2 text-sm text-(--text-muted,#6b7280)">{email}</p>
      {hasIndividualPremium && (
        <div className="mb-3 inline-flex items-center gap-1 rounded-full bg-linear-to-br from-amber-400 to-amber-500 px-2.5 py-1 text-xs font-medium text-amber-900">
          <span className="text-sm">★</span>
          <span>Individual Premium</span>
        </div>
      )}
      <div className="flex gap-2">
        <Button className="flex-1" onClick={handleOpenProfile}>
          Open Profile
        </Button>
      </div>
    </div>
  );
}
